import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import fourTheorem from '../../img/agenda/fourTheorem.png'
import Korkan from '../../img/agenda/Korkan.png'
import Mammino from '../../img/agenda/Mammino.png'
import Rahman from '../../img/agenda/Rahman.png'
import Redhat from '../../img/agenda/Redhat.png'
import Siemens from '../../img/agenda/Siemens.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
              {
                  id: 1,
                  time: '10:10',
                  photo: Korkan,
                  name: 'Ege Korkan',
                  position: 'Research Scientist',
                  tw: 'https://twitter.com/egekorkan',
                  logo: Siemens,
                  title: 'Bringing the Power of the Web to the IoT: Web of Things and node-wot',
                  abstract: `Web of Things is a group of standards by the World Wide Web Consortium (W3C) that allows to build IoT applications like we do Web Mashups. Even better, it allows one to abstract the underlying communication protocol, may it be HTTP that web developers are used to or Modbus that is used widely in manufacturing. This happens through Thing Descriptions (TDs), which can be considered analogous to OpenAPI documents but which allow the usage of multiple protocols.
                  The reference implementation of WoT is called node-wot, which allows developers to write programs to interact with real-world IoT devices through their TDs. As the name implies, it is implemented in Node.js and is governed by the Eclipse Foundation. node-wot lets developers focus on the pure application logic, may it be for controlling lights in a smart home or for a pick and place application in a factory. 
                  In this talk, I will show how easy it is to script such applications without using any protocol knowledge. We will write two scripts together that use the HTTP, CoAP and MQTT and show what Web of Things means for developers.`,
              },
              {
                  id: 2,
                  time: '10:50',
                  photo: Rahman,
                  name: 'Afreen Rahman',
                  position: 'Software engineer',
                  tw: 'https://twitter.com/afreenified',
                  logo: Redhat,
                  title: 'Whats up v8?',
                  abstract: `Talk is cheap! Lets dive into the internals of v8 and see how the heart of nodejs beats.
                  This will be a fun and engaging talks where you will walk away with decent undertsanding of v8.`,
              },
              {
                  id: 3,
                  time: '11:30',
                  photo: Mammino,
                  name: 'Luciano Mammino',
                  position: 'Senior Architect',
                  tw: 'https://twitter.com/loige',
                  logo: fourTheorem,
                  title: 'Finding a lost song with Node.js & async iterators',
                  abstract: `Did you ever get that feeling when a random song pops into your brain and you can’t get rid of it? Well, that happened to me recently and I couldn’t even remember the title of the damn song! In this talk, I want to share with you the story of how I was able to recover the details of the song by navigating some music-related APIs using JavaScript, Node.js and the magic of async iterators!`,
              },
          ],
        }
      }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h3 className="agenda_title">Agenda</h3>
                    <p className="agenda_undertitle">Time zone 0 UTC</p>
                    <p className="agenda_undertitle">May 18 10:00 - 21:00</p>
                    <p className="agenda_day">Junior Track</p>
                    <VideoPresent speakers={this.state.list}/>
                    <a className='full_agenda_btn' href='https://geekle.us/schedule/nodejs' target='_blank' rel="noreferrer">SHOW FULL AGENDA</a>
                </div>
            </div>
        );
    }
};